import React, { useEffect } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import CustomTable from "../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import { rolesListColumns } from "../../components/Columns/Roles";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";

const Roles = () => {
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: deleteRole } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    getUsersCall();
  }, []);

  const getUsersCall = () => {
    apiCall({
      url: apiUrls.sso.getRoles,
      method: "get",
    });
  }

  const onClickCreate = () => {
    navigate("/roles/create");
  };

  const deleteRoleApi = (id) => {
    deleteRole({
      url: apiUrls.sso.deleteRole + id,
      method: "delete",
      onSuccess: () => {
        toast.success("Group Deleted successfully");
        getUsersCall();
      },
    });
  }

  const editRole = (value) => {
    navigate("/roles/create", {state: value})
  }

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Roles"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <CustomButton
              title="Create Role"
              wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
              textClassName="text-[var(--blackColor)] pl-2"
              onClick={onClickCreate}
              icon={icons.plusBlackIcon}
            />
          );
        }}
      />

      <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-10 flex flex-col justify-center px-4 py-6 gap-y-5">
        <CustomTable
          isGlobalSearchEnable
          renderTools={() => {
            return (
              <InputWithIcon
                placeholder="Search"
                containerClassName="search-input-wrapper"
                inputClassName="font-size-small"
                rightIcon={icons.searchIcon}
              />
            );
          }}
          data={data}
          columns={rolesListColumns(deleteRoleApi, true, editRole)}
          showPageSizeChange
        />
      </div>
    </div>
  );
};

export default Roles;
